module.exports = __webpack_public_path__ + "static/media/letter-3-min.fd93839a.png";